import { render, staticRenderFns } from "./pollMessage.vue?vue&type=template&id=9cf6a548"
import script from "./pollMessage.vue?vue&type=script&lang=js"
export * from "./pollMessage.vue?vue&type=script&lang=js"
import style0 from "./pollMessage.vue?vue&type=style&index=0&id=9cf6a548&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_qhqm3mauky62uixplfzayyuc5e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports